module.exports = __webpack_public_path__ + "img/memberkit.7409cf32.png";